import { Outlet } from "react-router-dom";
import { Head } from "vite-react-ssg";
import { Header } from "./Header";
import { Footer } from "./Footer";

const SITE_URL = "https://mitzora.com";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col selection:bg-primary-container selection:text-on-primary-container">
      <Head>
        <meta property="og:site_name" content="Mitzora" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${SITE_URL}/dashboard.png`} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <Header />
      <main className="flex-1 pt-24 pb-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
